export const NAV_LINKS = [
  { label: "About", href: "about" },
  { label: "Science", href: "technology" },
  { label: "Pipeline", href: "pipeline" },
  { label: "Team", href: "team" },
  { label: "Contact", href: "contact" },
];

export const STATS = [
  { value: "12+", label: "Active programs" },
  { value: "40", label: "Research scientists" },
  { value: "8", label: "Global partners" },
  { value: "98%", label: "Assay precision" },
];

export const TECH_FEATURES = [
  {
    index: "01",
    title: "Gene Editing Platform",
    body: "Proprietary base-editing toolkit enabling single-nucleotide precision with minimal off-target activity.",
  },
  {
    index: "02",
    title: "AI Target Discovery",
    body: "Foundation models trained on multi-omic data surface novel, druggable targets in weeks, not years.",
  },
  {
    index: "03",
    title: "High-Throughput Screening",
    body: "Automated micro-fluidic labs run millions of parallel assays with sub-micron reproducibility.",
  },
  {
    index: "04",
    title: "Delivery Engineering",
    body: "Engineered lipid nanoparticles deliver payloads to tissue-specific targets with high uptake.",
  },
];

export const PIPELINE = [
  { code: "HX-101", area: "Oncology", indication: "Solid tumors", phase: "Phase II", progress: 60 },
  { code: "HX-204", area: "Rare disease", indication: "Hereditary anemia", phase: "Phase I", progress: 35 },
  { code: "HX-310", area: "Neurology", indication: "ALS", phase: "Preclinical", progress: 20 },
  { code: "HX-418", area: "Immunology", indication: "Lupus nephritis", phase: "Phase I", progress: 40 },
  { code: "HX-522", area: "Metabolic", indication: "NASH", phase: "Discovery", progress: 12 },
];

export const TEAM = [
  {
    name: "Dr. Lena Okafor",
    role: "Chief Executive Officer",
    img: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Dr. Marcus Reyes",
    role: "Head of Research",
    img: "https://images.pexels.com/photos/8442607/pexels-photo-8442607.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
  {
    name: "Dr. Sofia Andersen",
    role: "Chief Scientific Officer",
    img: "https://images.unsplash.com/photo-1758685848602-09e52ef9c7d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Dr. Daniel Mensah",
    role: "VP, Platform Engineering",
    img: "https://images.pexels.com/photos/8851627/pexels-photo-8851627.jpeg?auto=compress&cs=tinysrgb&w=800",
  },
];
